import { defineMessages } from 'react-intl';

const namespace = 'repvisits.ratings.';

const messages = defineMessages({
  overallFeedback: {
    id: `${namespace}overallFeedback`,
    defaultMessage: 'Overall Feedback',
  },
  feedbackBreakdown: {
    id: `${namespace}feedbackBreakdown`,
    defaultMessage: 'Feedback Breakdown',
  },
  topAreasToImprove: {
    id: `${namespace}topAreasToImprove`,
    defaultMessage: 'Top Areas To Improve',
  },
  staffMembers: {
    id: `${namespace}staffMembers`,
    defaultMessage: '{itemCount} staff {members}',
  },
  membersCount: {
    id: `${namespace}members`,
    defaultMessage: '{count, plural, one {member} other {members} }',
  },
  visitsCount: {
    id: `${namespace}visits`,
    defaultMessage: '{count, plural, one {visit} other {visits} }',
  },
  commentsCount: {
    id: `${namespace}comments`,
    defaultMessage: '{numComments, plural, one {comment} other {comments} }',
  },
  starsCount: {
    id: `${namespace}stars`,
    defaultMessage: '{stars, number} {stars, plural, one {star} other {stars} }',
  },
  averageRating: {
    id: `${namespace}averageRating`,
    defaultMessage: '{averageRating, plural, one {star} other {stars} }',
  },
  professionalism: {
    id: `${namespace}professionalism`,
    defaultMessage: 'professionalism',
  },
  materials: {
    id: `${namespace}materials`,
    defaultMessage: 'materials',
  },
  knowledge: {
    id: `${namespace}knowledge`,
    defaultMessage: 'knowledge',
  },
  other: {
    id: `${namespace}other`,
    defaultMessage: 'other',
  },

  anonymous: {
    id: `${namespace}anonymous`,
    defaultMessage: 'Anonymous ',
  },
  unknownUser: {
    id: `${namespace}unknown_user`,
    defaultMessage: 'Unknown User ',
  },
  at: {
    id: `${namespace}at`,
    defaultMessage: 'at',
  },
  submittedFeedback: {
    id: `${namespace}submitted-feedback`,
    defaultMessage: 'submitted visit feedback of',
  },
  loadMore: {
    id: `${namespace}load-more`,
    defaultMessage: 'Load more',
  },
  backToOverview: {
    id: `${namespace}back-overview`,
    defaultMessage: 'Go Back to <strong>Visit Feedback</strong>',
  },
  noRatings: {
    id: `${namespace}no-ratings`,
    defaultMessage: 'Insights into your team\'s reputation will appear here as staff members get feedback from high schools they visit.',
  },
});

export default messages;
